/* eslint-disable eqeqeq */
import { Item, ItemTypesEnum, QuizItem } from 'src/@types/Course';
import axiosInstance from 'src/utils/axios';
import { APIS } from 'src/utils/serviceUrls';
import * as Yup from 'yup';

export const Video_DocumentItemDefaultValues: Item = {
  title: '',
  description: '',
  details: {
    type: ItemTypesEnum.VIDEO,
  },
  duration: 0,
  points: 1,
  url: '',
  assets: [],
  isFreeToWatch: false,
};
export const QuizItemDefaultValues: Item = {
  title: '',
  description: '',
  details: {
    type: ItemTypesEnum.QUIZ,
    questions:[],
    attemptsLimit: 3,
    secondsPerQuestion: 0,
    passingScore: 50,
    questionsToServe: 0,
  } as QuizItem,
  duration: 0,
  assets: [],
  isFreeToWatch:false
};
export const Video_DocumentItemSchema = Yup.object().shape({
  title: Yup.string().required('Title is required').min(3, 'min 3 characters'),
  description: Yup.string(),
  url: Yup.string().required('Document is required'),
  duration: Yup.string().required('Item Duration in Minutes is required'),
});
export const DocumentItemSchema = Yup.object().shape({
  title: Yup.string().required('Title is required').min(3, 'min 3 characters'),
  description: Yup.string(),
  url: Yup.string().required('Document is required'),
});

// A Bunny-hosted lesson is stored with url '' plus its media id, which only the
// server sets (R1 §2.4): editing its title must not demand a url.
export const hasHostedMedia = (item?: Item) =>
  Boolean(item?.mediaId) || Boolean(item?.assetMediaIds?.length);

export const urlOptionalFor = <T extends Yup.AnyObjectSchema>(schema: T, item?: Item) =>
  hasHostedMedia(item) ? schema.shape({ url: Yup.string() }) : schema;

export const TextItemSchema = Yup.object().shape({
  title: Yup.string().required('Title is required').min(3, 'min 3 characters'),
  description: Yup.string(),
  body: Yup.string().required('Text is required'),
  duration: Yup.string().required('duration is required'),
});

export const TextItemDefaultValues: Item = {
  title: '',
  description: '',
  assets: [],
  details: {
    type: ItemTypesEnum.TEXT,
    body: '',
  },
  duration: 0,
  points: 1,
  isFreeToWatch:  false,
};
export const uploadFiles = async (file: File) => {
  const form = new FormData();
  form.append('file', file);
  let response = undefined;
  if (file.type == 'application/pdf')
    response = await axiosInstance.post(APIS.UPLOAD.DOCUMENT, form);
  else response = await axiosInstance.post(APIS.UPLOAD.MEDIA, form);
  return response.data;
};

export const QuizSchema = Yup.object().shape({
  title: Yup.string().required('Quiz Title Required '),
  duration: Yup.number().min(1).required('duration is required'),
  // points: Yup.number().min(1).required('points is required'),
  description: Yup.string(),
  details: Yup.object()
    .shape({
      questions: Yup.array(
        Yup.object()
          .shape({
            title: Yup.string().required('Question Title Required'),
            description: Yup.string(),
            multi: Yup.boolean(),
            answers: Yup.array(
              Yup.object({
                name: Yup.string().required('answer is Required'),
                 points: Yup.number().required('answer points is Required'),
                // minusPoints: Yup.number().required('answer minus points  is Required'),

                correct: Yup.boolean(),
              })
            ).required(),
          })
          .required()
      ).required(),
      type: Yup.string(),
      attemptsLimit: Yup.number().min(1).max(20),
      secondsPerQuestion: Yup.number().min(0).max(3600),
      passingScore: Yup.number().min(0).max(100),
      questionsToServe: Yup.number().min(0).max(500),
    })
    .required(),
});
